import React, { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Offer, PageWrapper, OfferCode } from '../../../../presentational';
import { useStore } from '../../../../hooks';
import { useIntl } from 'react-intl';
import { observer } from 'mobx-react-lite';

export const OfferClaim = observer(({ ...rest }) => {
	/**
	 * initialize hooks
	 */
	const intl = useIntl();
	const { Campaign, Influencer, discountCode, discountCodeDesc } = useStore();
	const { enqueueSnackbar } = useSnackbar();

	/**
	 * localization strings
	 */
	const LINK_LABEL = intl.formatMessage({
		id: 'incentive.general.codeLabel',
		defaultMessage: 'To redeem this discount, enter it during checkout',
		description: 'Label for a copyable, discount code for the user',
	});

	const COPY_SUCCESS = intl.formatMessage({
		id: 'incentive.general.copySuccess',
		defaultMessage: '✨ Code copied!',
		description:
			'Success popup that appears when a user clicks on the copy button.  This message includes a star emoji (✨) for style and can be kept, omitted, or changed for translation.',
	});

	useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	}, []);

	return (
		<>
			<PageWrapper>
				<Offer {...rest} />
				<OfferCode
					id='icsShareLink'
					label={LINK_LABEL}
					link={Influencer?.inviteLink}
					title={discountCode}
					code={discountCode}
					text={discountCodeDesc}
					marginBottom='lg'
					onCopy={() =>
						enqueueSnackbar(COPY_SUCCESS, {
							variant: 'info',
							autoHideDuration: 2500,
						})
					}
					marginTop='md'
				/>
			</PageWrapper>
		</>
	);
});
